<script setup lang="ts">
import { cn } from '@laam/lib/utils';
import {
	ProgressIndicator,
	ProgressRoot,
	type ProgressRootProps,
} from 'radix-vue';
import { type HTMLAttributes, computed } from 'vue';

const props = withDefaults(
	defineProps<ProgressRootProps & { class?: HTMLAttributes['class'] }>(),
	{
		modelValue: 0,
		class: '',
	},
);

const delegatedProps = computed(() => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { class: _, ...delegated } = props;

	return delegated;
});
</script>

<template>
	<ProgressRoot
		v-bind="delegatedProps"
		:class="
			cn(
				'relative h-md w-full overflow-hidden rounded-full bg-gray-200',
				props.class,
			)
		"
	>
		<ProgressIndicator
			class="h-full w-full flex-1 bg-blue-600 transition-all rounded-full"
			:style="`transform: translateX(-${100 - (props.modelValue ?? 0)}%);`"
		/>
	</ProgressRoot>
</template>
